import type { ReactNode } from 'react';
import type { ContentBlock } from '@oscom/shared';
import { RichTextView } from './RichTextView';

/** One stored hand block in the preview: text, note, warning or image. */
export function ContentBlockView({
  block,
  imageUrl,
}: {
  block: ContentBlock;
  imageUrl: (assetId: string) => string;
}): ReactNode {
  switch (block.type) {
    case 'richText':
      return <RichTextView doc={block.content} />;
    case 'note':
    case 'warning': {
      const label = block.type === 'note' ? 'Hinweis' : 'Warnung';
      return (
        <aside className={`callout callout--${block.type}`} aria-label={label}>
          <p className="callout__title">{label}</p>
          <RichTextView doc={block.content} />
        </aside>
      );
    }
    case 'image': {
      const width = block.layout?.widthPercent ?? 100;
      return (
        <figure className={`doc-image doc-image--w${width}`}>
          {/* No lazy loading: print and PDF must contain every image. */}
          <img src={imageUrl(block.asset.assetId)} alt={block.asset.alternativeText ?? ''} />
          {block.caption ? <figcaption>{block.caption}</figcaption> : null}
        </figure>
      );
    }
    default:
      return null;
  }
}
